import { createApi } from '@reduxjs/toolkit/query/react';

import fetchBaseQuery from '../fetchBaseQuery';

export type MachineTranslationEngine = 'google' | 'microsoft' | 'deepl';

export type GetMachineTranslationRequest = {
    engine: MachineTranslationEngine;
    translationId: string;
    toLanguageId: string;
    referenceLanguageId: string;
};

export type GetMachineTranslationResponse = {
    err: number;
    translated: string;
};

const translationApi = createApi({
    baseQuery: fetchBaseQuery(),
    reducerPath: 'translation',
    endpoints: (builder) => ({
        getMachineTranslation: builder.mutation<GetMachineTranslationResponse, GetMachineTranslationRequest>({
            query: ({ engine, translationId, toLanguageId, referenceLanguageId }) => ({
                url: `/translation/${translationId}/machine-translation`,
                method: 'POST',
                params: {
                    engine,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    to_lang: toLanguageId,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    from_lang: referenceLanguageId,
                },
            }),
        }),
    }),
});

export const { useGetMachineTranslationMutation } = translationApi;

export default translationApi;
